import React from 'react'
import { useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Loading from '../loadingScreen/Loading';

function AirWalllex() {

    useEffect(() => {
        const existingScript = document.getElementById('airwallex-fraud-api');
        if (existingScript) {
            existingScript.remove();
        }
        const params = new URLSearchParams(window.location.search);
        const encodedData = params.get("challengeData");
        const sanitized = encodedData.replace(/-/g, '+').replace(/_/g, '/');

        const decoded = atob(sanitized);
        const parsedData = JSON.parse(decoded);
        if (parsedData?.deviceDetailId) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'airwallex-fraud-api';
            script.setAttribute('data-order-session-id', parsedData.deviceDetailId);
            script.src = process.env.REACT_APP_AIRWALLEX_CDN;
            document.body.appendChild(script);
        }
        if (parsedData?.url) {
            setTimeout(() => {
                window.location.replace(`${parsedData.url}&deviceDetailId=${parsedData.deviceDetailId}`)
            }, 1000)
        }
        return () => {
            script.remove();
        };
    }, []);


    return (
        <div>
            <Loading
                text="Redirecting you to your bank for verification..."
                subText=""
            />
        </div>
    );
}

export default AirWalllex;
